import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { NavigationCacheService } from 'app/core/navigation/navigation-cache.service';

@Component({
    selector: 'app-access-denied',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, TranslocoModule],
    templateUrl: './access-denied.component.html',
    host: {
        class: 'flex w-full flex-auto flex-col min-h-0',
    },
})
export class AccessDeniedComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);
    private readonly navigationCache = inject(NavigationCacheService);

    attemptedUrl: string | null = null;

    ngOnInit(): void {
        const raw = this.route.snapshot.queryParamMap.get('attemptedUrl');
        this.attemptedUrl = raw?.trim() ? raw : null;
    }

    goToStart(): void {
        void this.router.navigateByUrl(this.navigationCache.getFirstRoute());
    }
}
